import React, {useState, useEffect, useRef, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { 
    Box, 
    Button, 
    IconButton,
    TextField, 
    Grid,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    FormHelperText
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { enqueueSnackbar } from 'notistack';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import { useSelector, useDispatch } from 'react-redux';

import Modal from '@mui/material/Modal';
import { constants } from '../../util'
import { showWaiting } from "../../store/slices/configSlice";
import { addAlbumArtist, getChatAlbum, sendMessageChatAlbum } from '../../services/albumService';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';



const Chat = ({albumId, albumName='', open, disableChat, onClose}) => {
    const messagesContainerRef = useRef(null);
    // const messagesEndRef = useRef(null);

    const dispatch = useDispatch();
    const {language, openSignup, deviceType} = useSelector(state => state.configuration);
    const [scroll, setScroll] = React.useState('paper');
    const [messages, setMessages] = React.useState([]);
    

    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const sch = (yup) => yup.object({
        message: yup.string().required().min(3).max(200)
    });
    const schema = useYupSchema(sch);

    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
                resolver: yupResolver(schema),
                defaultValues: {
                    message: '',
                }
            });



    const handleClose = () => {
        onClose(null);
        reset();
    }


    const scrollToBottom = useCallback(() => {
        const tryScroll = () => {
            if (messagesContainerRef.current) {
                messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
            } else {
                // Reintentar después de un breve tiempo si la ref aún no está lista
                setTimeout(tryScroll, 50);
            }
        };
        tryScroll();
    }, []);



    useEffect(() => {
        if (open) {
            scrollToBottom();
        }
    }, [open, messages, scrollToBottom]);

    

    useEffect(() => {
        setMessages([]);
        if (open){
            dispatch(showWaiting(true));
            getChatAlbum(albumId)
                .then( rsp => {
                    setTimeout(() => {
                        if (rsp.code === '00'){
                            setMessages(rsp.metadata);
                            dispatch(showWaiting(false));
                        }
                        dispatch(showWaiting(false));
                    }, 500);
                })
                .catch( error => {
                    dispatch(showWaiting(false));
                })
        }
    }, [open]);
    


    const onSubmit = (data) => {
        // dispatch(showWaiting(true));
        sendMessageChatAlbum(albumId, data.message)
            .then( rsp => {
                setTimeout(() => {
                    if (rsp.code === '00'){
                        setMessages(rsp.metadata);
                        // dispatch(showWaiting(false));
                    }
                    else
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false })
                    // dispatch(showWaiting(false));
                    reset();
                }, 100);
            })
            .catch( error => {
                // dispatch(showWaiting(false));
            })
    }



    return(
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{ '& .MuiDialog-paper': { width: '80%', maxWidth:'440px', height:'90%', maxHeight: '535px', overflow:'hidden' } }}
            >   
                <DialogTitle id="scroll-dialog-title" sx={{fontSize:'16px', flex:'.1'}}>
                    <b>{t("chat.title")}</b> - <b style={{color:'red'}}>{albumName}</b>
                    {/* <b>{`${t("chat.title")} - ${albumName}`}</b> */}
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent dividers={scroll === 'paper'} sx={{ flex:.8, overflow:'auto', backgroundColor:'#E9D4B4', padding:'20px'}}
                    ref={messagesContainerRef}
                >
                    <div style={{width:'100%', height:'100%'}}>
                        {
                            messages?.map(item => (
                                <div key={`msg${item.id}`} style={{
                                    backgroundColor: item.color.toLowerCase()==='green' ? '#2AF197' : '#FFFFFF',
                                    border: item.color.toLowerCase()==='green' ? '1px solid #1BBF75' : '1px solid #F0F0F0',
                                    borderRadius:'10px',
                                    width:'fit-content',
                                    maxWidth:'80%',
                                    padding:'8px',
                                    marginBottom:'15px',
                                    justifySelf:item.color.toLowerCase()==='green' ? 'flex-end' : 'flex-start',
                                }}>
                                    <strong>{item.who}: </strong>{item.message}
                                    <div style={{fontSize:10, color:'#667', justifySelf:'flex-end'}}>{item.sendDate}</div>
                                </div>
                            ))
                        }
                        {/* <div ref={messagesEndRef} /> */}
                    </div>
                </DialogContent>

                <DialogActions sx={{flex:'.1'}}>
                    <Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ display:'flex', flexDirection:'column', height:'100%', width:'100%' }}>
                        <div style={{display:'flex', width:'100%', paddingTop:'15px', paddingBottom:'10px'}}>
                            <div style={{flex:1}}></div>
                            <TextField id="txtMensaje" label={t("chat.txtMessage")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                {...register('message')}
                                error={!!errors.message}
                                helperText={errors.message?.message}
                                disabled={disableChat}
                            />
                            <Button
                                type="submit"
                                variant="outlined"
                                sx={{ ...constants.styles.mainButton, width: '20%', height:'55px', marginLeft:'10px' }}
                                disabled={disableChat}
                            >
                                {t("chat.btnSend")}
                            </Button>
                        </div>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Chat;